<template>
    <div id="recaptchaId" class="g-recaptcha">
    </div>
</template>

<script>
  const URL = "https://www.google.com/recaptcha/api.js";
  export default {
    mounted: function () {
      let getScripts = document.getElementsByTagName("script");
      let flag = false;
      for (let i = 0; i < getScripts.length; i++) {
        let script = getScripts[i];
        if (script.title === "recaptcha") {
          flag = true;
        }
      }

      if (!flag) {
        const script = document.createElement("script");
        script.src = `${URL}?render=explicit&hl=TR`;
        script.title = "recaptcha";
        script.async = true;
        script.defer = true;
        document.body.appendChild(script);
      }

      this.initReCaptcha();
    },
    data: function () {
      return {
        flag: true
      }
    },
    methods: {
      initReCaptcha() {
        setTimeout(function () {
          if (typeof grecaptcha === 'undefined') {
            this.initReCaptcha();
          }
          else {
            if (this.flag) {
              if (typeof grecaptcha.render === "function") {
                grecaptcha.render('recaptchaId', {
                  sitekey: '6LcfLMcZAAAAAOsP72T-pNF727R8pYlnIq4Hku_7',
                  callback: this.submit,
                  'onloadCallback': console.log("recaptcha loaded."),
                  'expired-callback': this.expired
                });
                this.$emit("loaded", grecaptcha);
                this.flag = false;
              }
              else {
                this.initReCaptcha();
              }
            }

          }
        }.bind(this), 100);
      },
      validate: function () {
        grecaptcha.execute();
      },
      submit: function (token) {
        this.$emit('verify', token)
      },
      expired: function (callback) {
        this.$emit('expired', callback)
      },
      reset: function () {
        grecaptcha.reset();
      }
    }
  }
</script>
